import { Component, ElementRef, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import axios from 'src/app/Service/axios';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
declare let $: any;

@Component({
  selector: 'taxi-meter',
  templateUrl: './taxiMetercomponent.html',
})
export class TaxiMeterComponent implements OnInit {
  constructor(
    private el: ElementRef,
    private notifyService: NotificationService,
    private router: Router,
    private otherService: OtherService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private gurdService: GurdServiceService
  ) {}
  domain: any;
  groupCar: any;
  carType: any;
  ajancyCostsModel: FormGroup = this.formBuilder.group({
    iMobileDomain:new FormControl("-1"),
    tiGPSType:new FormControl("-1"),
    tiMobileGroup:new FormControl("-1"),
    iSystemUser:new FormControl( this.gurdService.decrypt(window.localStorage.getItem('ID')!)),
      strSession:new FormControl(this.gurdService.decrypt(window.localStorage.getItem('Session')!)),
  });
  saveModel: FormGroup = this.formBuilder.group({
    iSystemUser:new FormControl( this.gurdService.decrypt(window.localStorage.getItem('ID')!)),
      strSession:new FormControl(this.gurdService.decrypt(window.localStorage.getItem('Session')!)),
      iEntranceFee :new FormControl("0"),
    iMinKM :new FormControl("0"),
    iMaxWait4GettingOn :new FormControl("0"),
    iStopFee :new FormControl("0"),
    iMoveFee :new FormControl("0"),
    iNormalMoveFee :new FormControl("0"),
    iHorlyFee :new FormControl("0"),
    iServiceFee :new FormControl("0"),
    iShippingFee :new FormControl("0"),
    iExclusiveFactor :new FormControl("0"),
    iTrafficplanPercentage :new FormControl("0"),
    iNightPercentage :new FormControl("0"),

  });
  ngOnInit(): void {
    this.getDomain();
    this.getGroup();
    this.getGpsType();
  }
  getDomain = async () => {
    const resp = await axios.post(
      `GetMobileDomain4Report?iSystemUser=${this.gurdService.decrypt(localStorage.getItem('ID')!)}`,
      {}
    );
    this.domain = JSON.parse(resp.data);
  };
  getGroup = async () => {
    const resp = await axios.post(`GetMobileGroup`, {});
    resp.data=JSON.parse(resp.data);
    this.groupCar = resp.data;
  };
  getGpsType= async () => {
    const resp= await axios.post(
        `GetGPSType`
      );
      this.carType = resp.data;
  }
  getAjancyCosts= async () =>{
    var model=this.ajancyCostsModel.value;
    const resp= await axios.post(
        `Taxi_GetAjancyCosts`,model
      );
      var resParse = JSON.parse(resp.data);
      if (resParse.iResult == 0) {
        this.notifyService.showError(resParse.strError);
        return;
      }
      else{
        this.saveModel.controls["iEntranceFee"].setValue(resParse.iEntranceFee);
        this.saveModel.controls["iExclusiveFactor"].setValue(resParse.iExclusiveFactor);
       // this.saveModel.controls["iFreewayMoveFee"].setValue(resParse.iFreewayMoveFee);
        //this.saveModel.controls["iFreewaySpeed"].setValue(resParse.iFreewaySpeed);
        this.saveModel.controls["iHorlyFee"].setValue(resParse.iHorlyFee);
       // this.saveModel.controls["iMaxNormalSpeed"].setValue(resParse.iMaxNormalSpeed);
        this.saveModel.controls["iMinKM"].setValue(resParse.iMinKM);
        this.saveModel.controls["iMoveFee"].setValue(resParse.iMoveFee);
        this.saveModel.controls["iNightPercentage"].setValue(resParse.iNightPercentage);
        this.saveModel.controls["iNormalMoveFee"].setValue(resParse.iNormalMoveFee);
        this.saveModel.controls["iServiceFee"].setValue(resParse.iServiceFee);
        this.saveModel.controls["iShippingFee"].setValue(resParse.iShippingFee);
        this.saveModel.controls["iStopFee"].setValue(resParse.iStopFee);
        this.saveModel.controls["iTrafficplanPercentage"].setValue(resParse.iTrafficplanPercentage);
        this.saveModel.controls["iUnNormalMoveFee"].setValue(resParse.iUnNormalMoveFee);
      }
  }
  seprator(e: any) {
    if (isNaN(e.key)) {
      return false;
    }
    this.otherService.insertComma(e);
    return true;
  }
  saveAjancyCosts(){
    var model=this.saveModel.value;
    var ajancyCostsModel=this.ajancyCostsModel.value;
    model.iMobileDomain=ajancyCostsModel.iMobileDomain;
    model.tiGPSType=ajancyCostsModel.tiGPSType;
    model.tiMobileGroup=ajancyCostsModel.tiMobileGroup;
    model.iEntranceFee= parseFloat(model.iEntranceFee.toString().replace(/,/g, ''));
    model.iMinKM= parseFloat(model.iMinKM.toString().replace(/,/g, ''));
    model.iMaxWait4GettingOn= parseFloat(model.iMaxWait4GettingOn.toString().replace(/,/g, ''));
    model.iStopFee= parseFloat(model.iStopFee.toString().replace(/,/g, ''));
    model.iMoveFee= parseFloat(model.iMoveFee.toString().replace(/,/g, ''));
    model.iNormalMoveFee= parseFloat(model.iNormalMoveFee.toString().replace(/,/g, ''));
    model.iServiceFee= parseFloat(model.iServiceFee.toString().replace(/,/g, ''));
    model.iShippingFee= parseFloat(model.iShippingFee.toString().replace(/,/g, ''));
    model.iExclusiveFactor= parseFloat(model.iExclusiveFactor.toString().replace(/,/g, ''));
    model.iTrafficplanPercentage= parseFloat(model.iTrafficplanPercentage.toString().replace(/,/g, ''));
    model.iNightPercentage= parseFloat(model.iNightPercentage.toString().replace(/,/g, ''));
    model.iHorlyFee= parseFloat(model.iHorlyFee.toString().replace(/,/g, ''));

    $.confirm({
      title: `آیا از ثبت اطلاعات اطمینان دارید ؟`,
      content: '',
      type: 'green',
      buttons: {
        ok: {
          text: "ثبت",
          btnClass: 'btn-primary',
          keys: ['enter'],
          action: async () => {
            const resp= await axios.post(
              `Taxi_SaveAjancyCosts`,model
            );
            var resParse = JSON.parse(resp.data);
            if (resParse.iResult == 0) {
              this.notifyService.showError(resParse.strError);
              return;
            }
            else{
              this.notifyService.showSuccess("با موفقیت ثیت شد");
              this.router.navigate(["/"]);
            }


            return;

          }
        },
        cancel: {
          text: "لغو",

        }
      }
    });
    
  }
}
